import { NgModule } from '@angular/core';

import { AssemblyPaymentsTerminalActionComponent } from './assembly-payments.terminal.actions.component';
import { SharedModule }                            from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    AssemblyPaymentsTerminalActionComponent
  ],
  entryComponents: [
    AssemblyPaymentsTerminalActionComponent
  ],
  imports: [
    SharedModule
  ]
})
export class AssemblyPaymentsModule {}
